import React, { useState } from 'react';
import { Tabs } from '../components/ui/Tabs';
import { SpotCard } from '../components/fishing/SpotCard';
import { SpeciesCard } from '../components/fishing/SpeciesCard';
import { spots, species } from '../utils/mockData';
import { useNavigate } from 'react-router-dom';
export function RecommendationsPage() {
  const [activeTab, setActiveTab] = useState('spots');
  const navigate = useNavigate();
  const tabs = [{
    id: 'spots',
    label: 'Top Spots'
  }, {
    id: 'species',
    label: 'Species'
  }, {
    id: 'times',
    label: 'Best Times'
  }];
  return <div className="p-4 md:p-8 pb-24 max-w-5xl mx-auto" data-id="element-166">
      <div className="mb-8" data-id="element-167">
        <h1 className="text-3xl font-bold text-text mb-2" data-id="element-168">
          Expert Recommendations
        </h1>
        <p className="text-text-muted" data-id="element-169">Curated tips for your next trip.</p>
      </div>

      <div className="mb-8" data-id="element-170">
        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} data-id="element-171" />
      </div>

      <div className="space-y-6" data-id="element-172">
        {activeTab === 'spots' && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-173">
            {spots.map((spot, index) => <div key={spot.id} className="relative" data-id="element-174">
                <div className="absolute -top-3 -left-3 w-8 h-8 bg-accent text-white font-bold rounded-full flex items-center justify-center z-10 shadow-lg border-2 border-surface" data-id="element-175">
                  #{index + 1}
                </div>
                <SpotCard spot={spot} onClick={() => navigate(`/spot/${spot.id}`)} data-id="element-176" />
              </div>)}
          </div>}

        {activeTab === 'species' && <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-177">
            {species.map(fish => <SpeciesCard key={fish.id} species={fish} data-id="element-178" />)}
          </div>}

        {activeTab === 'times' && <div className="bg-surface rounded-xl border border-border p-8 text-center" data-id="element-179">
            <div className="inline-block p-4 bg-primary/10 rounded-full text-primary mb-4" data-id="element-180">
              <svg className="w-12 h-12" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-181">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-182" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-text mb-2" data-id="element-183">
              Early Morning is Best
            </h3>
            <p className="text-text-muted max-w-md mx-auto" data-id="element-184">
              Based on current weather and moon phases, the highest activity is
              predicted between 5:00 AM and 8:00 AM.
            </p>
          </div>}
      </div>
    </div>;
}